import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES_NAMES } from './Layout';

interface AdminRouteProps {
    children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to={ROUTES_NAMES.AUTH} replace />;
    }

    if (!user || user.role !== 'admin') {
        return <Navigate to={ROUTES_NAMES.DASHBOARD} replace />;
    }

    return <>{children}</>;
};

export default AdminRoute;
